/* eslint-disable no-param-reassign */
import isEmpty from 'lodash/isEmpty';

const getAllGifts = list => {
  let tempArr = [];

  Object.keys(list).forEach(category => {
    if (list[category]) tempArr = [...tempArr, ...list[category]];
  });

  return tempArr;
};

const generateGifts = (giftGuide, filters, sortBy, sortAsc) => {
  const formattedList = {};

  Object.keys(giftGuide).forEach(entry => {
    if (!isEmpty(giftGuide[entry])) {
      const cat = giftGuide[entry].gift_category;
      const list = giftGuide[entry].entries;

      if (Array.isArray(list)) {
        list.forEach(gift => {
          if (gift.price && !Number.isNaN(Number(gift.price)))
            gift.price = parseFloat(gift.price);
        });

        formattedList[cat] = list;
      }
    }
  });

  let filteredGifts = [];
  const list = Object.values(filters.category.list);

  // If one or more filters are selected, filter out those gifts.
  // If not a single filter is selected, let all gifts through
  const selectedFilters =
    list.filter(({ selected }) => selected).reduce((acc, { name }) => {
      acc.push(name);
      return acc;
    }, []) || [];

  if (selectedFilters.length > 0) {
    for (let i = 0; i < selectedFilters.length; i += 1) {
      const filter = selectedFilters[i];

      if (filter === 'All Categories') {
        filteredGifts = getAllGifts(formattedList);
        break;
      } else if (formattedList[filter]) {
        filteredGifts = [...filteredGifts, ...formattedList[filter]];
      }
    }
  }

  filteredGifts = filteredGifts.sort((a, b) => {
    const aVal = (a || [])[sortBy];
    const bVal = (b || [])[sortBy];

    if (aVal < bVal) {
      return -1;
    }
    if (aVal > bVal) {
      return 1;
    }
    return 0;
  });

  if (!sortAsc) {
    return filteredGifts.reverse();
  }

  return filteredGifts;
};

export default generateGifts;
